import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20690e58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-credit" }
const _hoisted_2 = { class: "creditLabel" }
const _hoisted_3 = { class: "wrapper-slider" }
const _hoisted_4 = { class: "input-credit" }
const _hoisted_5 = { class: "creditLabel" }
const _hoisted_6 = { class: "wrapper-slider" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "input-wrapper" }
const _hoisted_9 = { class: "creditLabel-reason" }
const _hoisted_10 = { class: "reason-input" }
const _hoisted_11 = { class: "div-error-reason" }
const _hoisted_12 = { class: "btn-next" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_FormTextInput = _resolveComponent("FormTextInput")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputError = _resolveComponent("InputError")!
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_Transition, { name: "show-user-credit" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.creditData.text.titleLimits), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Slider, {
            id: "credit-slider",
            class: "slider",
            format: _ctx.format,
            min: Number(_ctx.minCredit),
            max: Number(_ctx.maxCredit),
            modelValue: _ctx.creditUser.limit,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.creditUser.limit) = $event))
          }, null, 8, ["format", "min", "max", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createVNode(_component_FormTextInput, {
            isInvalid: _ctx.invalidCredit,
            errors: _ctx.errorsCredit,
            id: "input-credit-slider",
            name: "input-credit-slider",
            class: "current-value",
            modelValue: _ctx.creditFormatted,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.creditFormatted) = $event))
          }, null, 8, ["isInvalid", "errors", "modelValue"]), [
            [_directive_maska, [
                        'R$ ##.###,##',
                        'R$ ###.###,##',
                        'R$ #.###.###,##',
                    ]]
          ])
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.creditData.titleInstallments), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Slider, {
            id: "installments-slider",
            class: "slider",
            min: 6,
            max: 36,
            step: 1,
            modelValue: _ctx.creditUser.installment,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.creditUser.installment) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_InfoBox, { class: "info-box" }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.creditData.text.titleFaturamento) + " ", 1),
              _hoisted_7,
              _withDirectives(_createElementVNode("b", null, " R$ " + _toDisplayString(_ctx.minIncome), 513), [
                [_vShow, 
                            _ctx.requestStatus == _ctx.ERequestStatus.Done ||
                            _ctx.requestStatus == _ctx.ERequestStatus.Idle
                        ]
              ]),
              _withDirectives(_createElementVNode("i", null, _toDisplayString(`Calculando... `), 513), [
                [_vShow, 
                            _ctx.requestStatus == _ctx.ERequestStatus.Debounced ||
                            _ctx.requestStatus == _ctx.ERequestStatus.InProgress
                        ]
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.creditData.text.titleMotivo), 1),
          _createVNode(_component_MultiSelect, {
            class: "select-reason",
            options: _ctx.creditData.text.listReasons,
            modelValue: _ctx.reason,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reason) = $event)),
            placeholder: "Selecione uma opção"
          }, null, 8, ["options", "modelValue"]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.reason === _ctx.others)
              ? (_openBlock(), _createBlock(_component_FormTextInput, {
                  key: 0,
                  modelValue: _ctx.reasonOthers,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reasonOthers) = $event)),
                  placeholder: "Escreva seu motivo",
                  name: "Motivo"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            _createVNode(_component_InputError, {
              msg: _ctx.creditData.text.errors
            }, null, 8, ["msg"])
          ], 512), [
            [_vShow, _ctx.isInvalid]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_ButtonDefault, {
            id: "btn-step-next-slider",
            msg: "Continuar",
            onButtonClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSubmit()))
          })
        ])
      ])
    ]),
    _: 1
  }))
}